import { createContext, useContext } from "react";
import { UI_ZOOM } from "../constants/designTokens";

export { UI_ZOOM };
export const UI_ZOOM_MEDIA = "(min-width:600px)";

/** A length inside the page's zoom, sized as the unzoomed page would size it. */
export const unzoomed = (length: string) => `calc(${length} / var(--yc-zoom, 1))`;

/** The page's own interface size. Partner pages aren't zoomed (only the nav, header and tables are), so it is 1. */
export const UiZoomContext = createContext(1);

export const useUiZoom = () => useContext(UiZoomContext);
